module.exports = __webpack_public_path__ + "img/shower_door_installation.09dea6cb.jpg";